import React from 'react';
import { useAirtableDrinks } from '../hooks/useAirtableDrinks';
import { Loader } from '../Loader';

interface FieldProps {
  product_name: string;
  product_cost: string[];
  product_description: string;
  product_number: number;
}

export const DrinkItems = (): React.ReactElement => {
  const [drinkItems, isLoading] = useAirtableDrinks();

  if (isLoading) return <Loader />

  return (
    <div className='container mx-auto w-full md:w-2/3 mb-14 border-2 border-b-0'>
      {drinkItems.map(({ fields }: { fields: FieldProps }) => {
        return (
          <div
            key={fields.product_number}
            className='
              flex flex-row gap-4 md:gap-0
              items-center justify-between
              p-4 border-b-2'
          >
            <div className='flex w-full gap-2'>
              <p className='text-4xl md:text-base'>#{fields.product_number}</p>
              <div className='flex flex-col'>
                {fields.product_name && (
                  <div className='mb-1'>
                    <p className='font-black'>{fields.product_name}</p>
                  </div>
                )}

                <p className='text-lg md:text-sm text-gray-400'>{fields.product_description}</p>
              </div>
            </div>

            <div className='flex items-center gap-2'>
              {fields.product_cost?.map((cost, index) => {
                return (
                  <div className='flex flex-col items-center p-4 border-2 border-black rounded-xl'>
                    <p>{cost}</p>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
